<!-- 手动分析续费订单 -->
<template>
  <Modal
      v-model="_value"
      width="700"
      title="手动分析续费订单"
      @on-visible-change="visibleChange"
      ok-text="确认"
      @on-ok="onOk">
    <div style="text-align: center;display: flex;">

    <div class="ivu-transfer-list" style="margin-right: 30px;margin: auto;">
      <div class="ivu-transfer-list-header">
        <label class="ivu-checkbox-wrapper ivu-checkbox-wrapper-disabled ivu-checkbox-default">
          <span class="ivu-checkbox ivu-checkbox-disabled">
            <span>查询</span>
<!--            <span class="ivu-checkbox-inner"></span>-->
<!--            <input type="checkbox" disabled="disabled" class="ivu-checkbox-input">-->
          </span> <!---->
        </label>
<!--        <span class="ivu-transfer-list-header-title">-->
<!--          源列表-->
<!--        </span>-->
<!--        <span class="ivu-transfer-list-header-count">-->
<!--          0-->
<!--        </span>-->
      </div>
      <div class="ivu-transfer-list-body ivu-transfer-list-body-with-search">
        <div class="ivu-transfer-list-body-search-wrapper">
          <div class="ivu-transfer-list-search">
            <div class="ivu-input-wrapper ivu-input-wrapper-small ivu-input-type-text"><!---->
              <i class="ivu-icon ivu-icon-ios-search ivu-input-icon ivu-input-icon-normal"></i>
              <!----> <input autocomplete="off" spellcheck="false" type="text" placeholder="请输入搜索内容" class="ivu-input ivu-input-small" v-model="vehicleinfogroup" @change="onVehicleinfogroup">
              <!----></div>
          </div>
        </div>
<!--        <ul class="ivu-transfer-list-content">-->
        <ul>
<!--          <li class="ivu-transfer-list-content-not-found" v-if="defaultGroupData.length = 0">列表为空</li>-->
<!--          <li class="ivu-transfer-list-content-not-found" v-for="(item, key) in defaultGroupData">{{item.title}}</li>-->
          <li v-for="(item, key) in defaultGroupData" @click="getVehicleinfo(item)">{{item.title}}</li>
        </ul>
      </div> <!---->
    </div>

    <Transfer
      :titles="titles"
      :data="data"
      :target-keys="targetKeys"
      filterable
      remote
      :remote-method="remote"
      :filter-method="filterMethod"
      @on-change="handleChange"
      style="margin: auto;"
    >
    </Transfer>

    </div>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'renewalorderbatchmanualmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      titles: ['选择列表', '分析列表'],
      // data: this.getMockData(),
      data: [],
      // targetKeys: this.getTargetKeys(),
      targetKeys: [],

      // 车辆分组名称
      vehicleinfogroup: null,
      // 分组列表
      defaultGroupData: []

    }
  },
  methods: {
    ...mapActions([
      'RenewalOrderServ_ConfirmRecept'
    ]),
    // 查询车辆分组
    onVehicleinfogroup () {
      this.defaultGroupData = []
      console.log(this.vehicleinfogroup)
      if (this.vehicleinfogroup) {
        console.log('加载')
        store.dispatch('VehicleInfoGroupServ_SearchByName', {
          params: { name: this.vehicleinfogroup },
          urlparams: null
        }).then(() => {
          console.log(store.getters.get_VehicleInfoGroup_SearchByNameResult.length)
          if (store.getters.get_VehicleInfoGroup_SearchByNameResult.length != 0) {
            let result = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
            result.forEach(item => {
              this.defaultGroupData.push({
                id: item.id,
                title: item.name,
                expand: false,
                loading: false,
                children: []
              })
            })
          } else {
            store.dispatch('VehicleInfoServ_SearchByName', {
              params: { name: this.vehicleinfogroup },
              urlparams: null
            }).then(() => {
              let result = store.getters.get_VehicleInfo_SearchByNameResult ? store.getters.get_VehicleInfo_SearchByNameResult : []
              this.data = this.getMockData(result)
            }).catch(err => {
            })
          }
        }).catch(err => {
        })
      } else {
        this.refreshRootVehicleInfoGroups()
      }
    },
    refreshRootVehicleInfoGroups () {
      store.dispatch('VehicleInfoGroupServ_GetRootVehicleInfoGroups', {
        params: null,
        urlparams: null
      }).then(() => {
        let result = store.getters.get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult ? store.getters.get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult : []
        result.forEach(item => {
          this.defaultGroupData.push({
            id: item.id,
            title: item.name,
            expand: false,
            loading: false,
            children: []
          })
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    // 查询分组车辆列表
    getVehicleinfo (e) {
      console.log(e)
      let queryParams = []
      if (e) {
        queryParams.push(genQueryParam('vehicleInfoGroupId', 'EQ', e.id))
      } else {
        queryParams.push(genQueryParam('vehicleInfoGroupId', 'EQNULL', null))
      }
      store.dispatch('VehicleInfoServ_GetAll', {
        params: null,
        urlparams: {
          q: queryParams,
          keyword: this.keywordFilter
        }
      }).then(() => {
        let result = store.getters.get_VehicleInfo_GetAllResult ? store.getters.get_VehicleInfo_GetAllResult : []
        this.data = this.getMockData(result)
      }).catch(err => {

      })
    },

    onOk () {
      console.log(this.targetKeys)
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认分析</p>',
        onOk: () => {
          store.dispatch('RenewalOrderServ_TchManualGenerateRenewalOrders', {
            params: {
              vehicleInfoIds: this.targetKeys
            },
            uelparams: null
          }).then(res => {
            // console.log(res)
            // let result = res.msg.split(';')
            // console.log(result)
            // result.forEach(item => {
            //   item.split(':')
            // })
            // this.$Message.success(res.msg)
            this.$Message.success({
              content: res.msg,
              duration: 0,
              closable: true
            });
            this.$emit('on-success')
          }).catch(err => {
            console.log(err)
            this.$Message.error(err)
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {

      }
    },
    getMockData (e) {
      console.log(e)
      let mockData = []
      e.forEach(item => {
        mockData.push({
          key: item.id,
          label: item.registrationNum
          // description: 'The desc of content  ' + i,
          // disabled: Math.random() * 3 < 1
        })
      })
      return mockData
    },
    getTargetKeys (e) {
      console.log(e)
      return this.getMockData(e)
        .filter(() => Math.random() * 2 > 1)
        .map(item => item.key)
    },
    handleChange (newTargetKeys) {
      console.log(newTargetKeys)
      this.targetKeys = newTargetKeys
    },
    filterMethod (data, query) {
      // console.log(query)
      // console.log(data)
      // if (data == null && data.length == 0) {
      //   store.dispatch('VehicleInfoServ_SearchByName', {
      //     params: {name: query},
      //     urlparams: null
      //   }).then(() => {
      //     console.log(store.getters.get_VehicleInfo_SearchByNameResult)
      //     this.getTargetKeys(store.getters.get_VehicleInfo_SearchByNameResult)
      //     // this.searchVehicleInfoList = store.getters.get_VehicleInfo_SearchByNameResult ? store.getters.get_VehicleInfo_SearchByNameResult : []
      //   }).catch(err => {
      //     console.log(err);
      //   })
      // }
      return data.label.indexOf(query) > -1
    },
    remote (e) {
      console.log(e)
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
